import { render, staticRenderFns } from "./EditCriteria.vue?vue&type=template&id=442c869f&"
import script from "./EditCriteria.vue?vue&type=script&lang=js&"
export * from "./EditCriteria.vue?vue&type=script&lang=js&"
import style0 from "./EditCriteria.vue?vue&type=style&index=0&id=442c869f&prod&scopped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports